import axios, { AxiosInstance } from "axios";
import {
    ERP_BASE_URL,
    ERP_BASE_URL_AUTHENTICATION,
    ERP_BASE_URL_DATA_SCIENCE_REPORTS,
} from "../config/apiConfig";

/**
 * Handles unauthorized responses (401/403) by clearing auth data and redirecting to login.
 */
const handleUnauthorized = (): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("authority");
  localStorage.removeItem("name");
  window.location.href = "/";
};

/**
 * Adds auth interceptor to an axios instance to handle 401/403 responses.
 */
const addAuthInterceptor = (instance: AxiosInstance): AxiosInstance => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

/**
 * Creates an axios instance with default config and auth interceptor.
 */
const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return addAuthInterceptor(instance);
};

// Main ERP API instance
export const erpAxios = createAxiosInstance(ERP_BASE_URL);

// Authentication API instance
export const authAxios = createAxiosInstance(ERP_BASE_URL_AUTHENTICATION);

// Data Science Reports API instance
export const reportsAxios = createAxiosInstance(ERP_BASE_URL_DATA_SCIENCE_REPORTS);

// Helper to get token from localStorage
export const getAuthToken = (): string | null => localStorage.getItem("token");
